/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * head object
 * @export
 * @interface GetCharactersCharacterIdPlanetsPlanetIdHead
 */
export interface GetCharactersCharacterIdPlanetsPlanetIdHead {
    /**
     * head_id integer
     * @type {number}
     * @memberof GetCharactersCharacterIdPlanetsPlanetIdHead
     */
    headId: number;
    /**
     * latitude number
     * @type {number}
     * @memberof GetCharactersCharacterIdPlanetsPlanetIdHead
     */
    latitude: number;
    /**
     * longitude number
     * @type {number}
     * @memberof GetCharactersCharacterIdPlanetsPlanetIdHead
     */
    longitude: number;
}

/**
 * Check if a given object implements the GetCharactersCharacterIdPlanetsPlanetIdHead interface.
 */
export function instanceOfGetCharactersCharacterIdPlanetsPlanetIdHead(value: object): value is GetCharactersCharacterIdPlanetsPlanetIdHead {
    if (!('headId' in value) || value['headId'] === undefined) return false;
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    return true;
}

export function GetCharactersCharacterIdPlanetsPlanetIdHeadFromJSON(json: any): GetCharactersCharacterIdPlanetsPlanetIdHead {
    return GetCharactersCharacterIdPlanetsPlanetIdHeadFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdPlanetsPlanetIdHeadFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdPlanetsPlanetIdHead {
    if (json == null) {
        return json;
    }
    return {
        
        'headId': json['head_id'],
        'latitude': json['latitude'],
        'longitude': json['longitude'],
    };
}

export function GetCharactersCharacterIdPlanetsPlanetIdHeadToJSON(json: any): GetCharactersCharacterIdPlanetsPlanetIdHead {
    return GetCharactersCharacterIdPlanetsPlanetIdHeadToJSONTyped(json, false);
}

export function GetCharactersCharacterIdPlanetsPlanetIdHeadToJSONTyped(value?: GetCharactersCharacterIdPlanetsPlanetIdHead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'head_id': value['headId'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
    };
}

